import { Store } from 'redux';
import { AppStates } from '../reducers/app';
import { initGlobalFrameStore } from './FrameStore';
import { initAnimationFrameTrigger } from './AnimationFrameTrigger';

const initServices = (store: Store<AppStates>) => {
  initGlobalFrameStore(store);
  initAnimationFrameTrigger(store);
};

export default initServices;
